import { render } from "./Arena_Status.vue?vue&type=template&id=3e9fd65a&scoped=true"
import script from "./Arena_Status.vue?vue&type=script&lang=js"
export * from "./Arena_Status.vue?vue&type=script&lang=js"

import "./Arena_Status.vue?vue&type=style&index=0&id=3e9fd65a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e9fd65a"]])

export default __exports__